/**************************************************
 * Nombre:       Seccion_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Portada from "./Componentes/Home_Portada";
import Home_Lineas from "./Componentes/Home_Lineas";
import Home_Resultados from "./Componentes/Home_Resultados";
import Home_Puedo_Ayudarte from "./Componentes/Home_Puedo_Ayudarte";
import Home_Lleva_Tu_Marca from "./Componentes/Home_Lleva_Tu_Marca";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {SECCIONES} from "../../Constantes";

const Seccion_Home = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 6}}>
                <Home_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 10}}>
                <Home_Lineas/>
            </Grid>

            <Grid id={SECCIONES[1]} container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 12}}>
                <Home_Resultados/>
            </Grid>

            <Grid id={SECCIONES[0]} container size={{xs: 12, sm: 12, md: 12}} sx={{mt:  sCell ? 10 : 14}} >
                <Home_Puedo_Ayudarte/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 16}} >
                <Home_Lleva_Tu_Marca/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Home